import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "./components/ui/toaster";
import ScrollToTop from "./components/ScrollToTop";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsAppFloat from "./components/WhatsAppFloat";
import Home from "./pages/Home";
import About from "./pages/About";
import BestLiverDoctor from "./pages/BestLiverDoctor";
import FattyLiver from "./pages/FattyLiver";
import Cirrhosis from "./pages/Cirrhosis";
import Hepatitis from "./pages/Hepatitis";
import Jaundice from "./pages/Jaundice";
import Investigations from "./pages/Investigations";
import LiverSymptoms from "./pages/LiverSymptoms";
import Contact from "./pages/Contact";

// Active pages with their canonical (new) paths
const pages = [
  { path: "/", element: <Home /> },
  { path: "/gastro-liver-specialist-dr-indresh-dixit", element: <About /> },
  { path: "/best-liver-doctor-in-varanasi", element: <BestLiverDoctor /> },
  { path: "/fatty-liver-treatment-varanasi", element: <FattyLiver /> },
  { path: "/liver-cirrhosis-treatment-varanasi", element: <Cirrhosis /> },
  { path: "/hepatitis-treatment-varanasi", element: <Hepatitis /> },
  { path: "/jaundice-treatment-varanasi", element: <Jaundice /> },
  { path: "/liver-tests-varanasi", element: <Investigations /> },
  { path: "/liver-disease-symptoms", element: <LiverSymptoms /> },
  { path: "/contact", element: <Contact /> },
];

// Old paths -> new paths (client-side redirects)
const redirects = [
  { from: "/about", to: "/gastro-liver-specialist-dr-indresh-dixit" },
  { from: "/fatty-liver-treatment", to: "/fatty-liver-treatment-varanasi" },
  { from: "/liver-cirrhosis-treatment", to: "/liver-cirrhosis-treatment-varanasi" },
  { from: "/hepatitis-treatment", to: "/hepatitis-treatment-varanasi" },
  { from: "/jaundice-treatment", to: "/jaundice-treatment-varanasi" },
  { from: "/liver-investigations", to: "/liver-tests-varanasi" },
  { from: "/liver-symptoms", to: "/liver-disease-symptoms" },
];

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Navbar />
          <main>
            <Routes>
              {pages.map((p) => (
                <Route key={p.path} path={p.path} element={p.element} />
              ))}
              {/* trailing-slash variants */}
              {pages.filter((p) => p.path !== "/").map((p) => (
                <Route key={p.path + "/"} path={p.path + "/"} element={p.element} />
              ))}
              {/* redirects from old URLs */}
              {redirects.map((r) => (
                <Route key={r.from} path={r.from} element={<Navigate to={r.to} replace />} />
              ))}
              {/* fallback */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
          <Footer />
          <WhatsAppFloat />
          <Toaster />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
